import { ValueOf } from '~/lib/@types/helpers';

const cmsHeaderLayout = 'SliceMachineSlicesCmsHeaderLayout';
const homepageHeaderLayout = 'SliceMachineSlicesHomepageHeaderLayout';
const instagramFeedLayout = 'SliceMachineSlicesInstagramFeedLayout';
const largeTextLayout = 'SliceMachineSlicesLargeTextLayout';
const mondrianLayout = 'SliceMachineSlicesMondrianLayout';
const imageAndTextLayout = 'SliceMachineSlicesImageAndTextLayout';
const imageBannerAndTitle = 'SliceMachineSlicesImageBannerAndTitleLayout';
const tilesListLayout = 'SliceMachineSlicesTilesListLayout';
const teamLayout = 'SliceMachineSlicesTeamLayout';
const threeColumnsLayout = 'SliceMachineSlicesThreeColumnsLayout';
const flexibleTextLayout = 'SliceMachineSlicesFlexibleTextLayout';
const aaltoSceneLayout = 'SliceMachineSlicesAaltoSceneLayout';
const wysiwygLayout = 'SliceMachineSlicesWysiwygLayout';
const contactFormLayout = 'SliceMachineSlicesContactFormLayout';
const imagesGalleryLayout = 'SliceMachineSlicesImagesGalleryLayout';
const singleMediaLayout = 'SliceMachineSlicesSingleMediaLayout';

export const typenames = {
  cmsHeaderLayout,
  homepageHeaderLayout,
  instagramFeedLayout,
  largeTextLayout,
  mondrianLayout,
  imageAndTextLayout,
  imageBannerAndTitle,
  tilesListLayout,
  teamLayout,
  threeColumnsLayout,
  flexibleTextLayout,
  aaltoSceneLayout,
  wysiwygLayout,
  contactFormLayout,
  imagesGalleryLayout,
  singleMediaLayout,
} as const;

export type ContentBlockSlicesTypenames = ValueOf<typeof typenames>;
